import React from 'react';

interface WidgetHeaderWrapperProps {
    [type: string]: any;
}

/**
 * The widget header can be clickable if the widget is collapsible.
 * In that case, use a button instead of a div.
 */
export const WidgetHeaderWrapper: React.FC<WidgetHeaderWrapperProps> = ({ onClick, children, ...headerProps }) =>
    onClick ? (
        /* eslint-disable-next-line react/forbid-elements */
        <button type="button" onClick={onClick} {...headerProps}>
            {children}
        </button>
    ) : (
        // eslint-disable-next-line react/forbid-elements
        <span {...headerProps}>{children}</span>
    );

WidgetHeaderWrapper.displayName = 'WidgetHeaderWrapper';
